import { useMutation } from '@tanstack/react-query';

import {
  createSubscription as createSubscriptionApi,
  IOrderResponseDto,
  ISubscriptionDataRequestDto,
  ISubscriptionParamsRequestDto,
} from '@/shared/api/subscriptions';

export function useCreateSubscription() {
  const createSubscriptionMutation = useMutation({
    mutationFn: ({
      subscriptionData,
      params,
    }: {
      subscriptionData: ISubscriptionDataRequestDto;
      params: ISubscriptionParamsRequestDto;
    }) => {
      return createSubscriptionApi(subscriptionData, params);
    },
  });

  const createSubscription = (
    data: {
      subscriptionData: ISubscriptionDataRequestDto;
      params: ISubscriptionParamsRequestDto;
    },
    onCreated?: (data: IOrderResponseDto) => void
  ) => {
    return createSubscriptionMutation.mutateAsync(data, {
      onSuccess: onCreated,
    });
  };

  return {
    createSubscription,
    ...createSubscriptionMutation,
  };
}
